import { render, staticRenderFns } from "./employee__form.vue?vue&type=template&id=08138198"
import script from "./employee__form.vue?vue&type=script&lang=js"
export * from "./employee__form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports